<template>
  <div id="app">
    <el-container class="page" v-if="authorized">
      <page-header />
      <el-main>
        <el-row>
          <el-col :span="18">
            <router-view />
          </el-col>
          <el-col :span="6" style="padding-left: 12px">
            <company-card />
          </el-col>
        </el-row>
      </el-main>
    </el-container>
    <router-view v-else />
  </div>
</template>

<script>
import { mapState } from "vuex";
import CompanyCard from "./components/company-card";
import PageHeader from "./components/page-header";

export default {
  name: "app",
  components: { CompanyCard, PageHeader },
  data: () => ({}),
  async created() {
    await this.$store.dispatch("updateUser");
  },
  computed: {
    ...mapState(["authorized"])
  }
};
</script>

<style lang="scss">
html,
body {
  padding: 0;
  margin: 0;
  height: 100%;
}
body {
  overflow-y: scroll;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
</style>

<style lang="scss">
.el-main {
  overflow: inherit !important;
}
.page {
  width: 1240px;
  margin: 0 auto;

  display: block !important;

  .el-card {
    text-align: left;

    .client .row {
      font-size: 12px;
      margin: 0 0 8px 0;
      white-space: nowrap;

      * {
        display: inline-block;
        white-space: normal;
        word-wrap: break-word;
      }
      .title {
        vertical-align: top;
        font-weight: bold;
        width: 80px;
      }
      .description {
        width: 160px;
      }
    }
  }
}
.subheader {
  display: block;
  font-size: 12px;
  padding-top: 8px;
  color: #999;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
</style>